import React from "react";
import AxiosClient from "../../../../Network/AxiosClient";
import { Button, Icon, TextInput } from "react-materialize";
import { connect } from "react-redux";
import Pagination from "../../../layout/Pagination";
import "./FSETable.styles.scss";
import CreateModal from "./components/CreateModal/CreateModal";
import Dropdown from "../MDOTable/components/Dropdown/Dropdown";
import TableWorker from "./components/TableWorker/TableWorker";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import SkeletonRow from "../../../InventoryManagement/components/Common/SkeletonRow";
import ErrorCard from "../../../InventoryManagement/components/Common/ErrorCard";
import EmptyCard from "../../../InventoryManagement/components/Common/EmptyCard";
import { setPage } from "../../../../store/actions/paginationAction";

const show_checkBoxes = [
  { label: "View all", value: "all" },
  { label: "Active", value: "activated" },
  { label: "Deactivated", value: "deactivated" },
];

const empolyee_types = [
  { id: "office_manager", name: "Office manager" },
  { id: "peon", name: "Peon" },
  { id: "security_guard", name: "Security guard" },
  { id: "cleaner", name: "Cleaner" },
];

class BackOfficeEmployeeTable extends React.Component {
  constructor() {
    super();
    this.searchDebounceTimeout = null;

    this.state = {
      showCreateModal: false,

      fetchingOfficeEmployeeTableData: true,
      officeEmployeeFetchError: false,

      total: "",
      page: "",
      limit: "",
      officeEmployeeTableData: [],

      selectedOption: [],
      selectedFilter: "",
      selectedAgency: "",
      selectedEmployeeType: "",

      search: "",
      agencies: [],

      reset: true,
      showOfficeEmployeeByActivation: "all",
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentLimit !== prevProps.currentLimit
    )
      this.getData();
  }

  componentWillUnmount() {
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
    }
  }

  resetPage = () => {
    if (this.props.currentPage !== 0) {
      this.props.setPage("fsetable", 0);
      return true;
    }

    return false;
  };

  reset_toggle = () => {
    this.setState({ reset: !this.state.reset });
  };

  componentDidMount() {
    this.loadAgencies();
    this.getData();
  }

  getData = () => {
    this.setState({
      fetchingOfficeEmployeeTableData: true,
      officeEmployeeFetchError: false,
    });
    let isActiveValue = "";
    if (this.state.showOfficeEmployeeByActivation === "activated") {
      isActiveValue = "True";
    } else if (this.state.showOfficeEmployeeByActivation === "deactivated") {
      isActiveValue = "False";
    }
    const isActiveParam = isActiveValue ? `&is_active=${isActiveValue}` : "";

    AxiosClient.get(
      `${
        process.env.REACT_APP_API_URL
      }/api/admin_panel/v1/office-employee?search_term=${
        this.state.search
      }&page_index=${this.props.currentPage}&page_size=${parseInt(
        this.props.currentLimit
      )}${isActiveParam}${this.state.selectedFilter}`
    )
      .then((res) => {
        return this.setState({
          total: res.data.count,
          page: res.data.page,
          limit: res.data.limit,
          officeEmployeeTableData: res.data.data,
        });
      })
      .catch((err) => {
        this.setState({
          officeEmployeeFetchError: true,
        });
        console.log(err);
      })
      .finally(() => {
        this.setState({ fetchingOfficeEmployeeTableData: false });
      });
  };

  handleOptionChange = (selectedOption) => {
    this.setState({ selectedOption });

    let filter =
      selectedOption !== null
        ? selectedOption.map((option) => `&agency=${option.id}`).join("")
        : "";

    this.setState(
      (prevState) => ({
        selectedFilter: prevState.selectedEmployeeType + filter,
        selectedAgency: filter,
      }),
      () => {
        if (this.resetPage()) return;
        this.getData();
      }
    );
  };

  handleTypeChange = (selectedOption) => {
    this.setState({ selectedOption });

    let filter =
      selectedOption !== null
        ? selectedOption.map((option) => `&type=${option.id}`).join("")
        : "";

    this.setState(
      (prevState) => ({
        selectedFilter: prevState.selectedAgency + filter,
        selectedEmployeeType: filter,
      }),
      () => {
        if (this.resetPage()) return;
        this.getData();
      }
    );
  };

  handleSearch = (event) => {
    this.setState({ search: event.target.value }, () => {
      if (this.searchDebounceTimeout) {
        clearTimeout(this.searchDebounceTimeout);
      }

      this.searchDebounceTimeout = setTimeout(() => {
        if (this.resetPage()) return;
        this.getData();
      }, 250);
    });
  };

  showCreateModal = () => this.setState({ showCreateModal: true });
  hideCreateModal = () => this.setState({ showCreateModal: false });

  loadAgencies = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/agency`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        this.setState({
          agencies: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };

  handleSubmit = () => {
    this.getData();
  };

  toggleShowOfficeEmployeeByActivation = (value) => {
    if (this.state.showOfficeEmployeeByActivation === value) return;
    this.setState({ showOfficeEmployeeByActivation: value }, () => {
      if (this.resetPage()) return;
      this.getData();
    });
  };

  render() {
    const userType = JSON.parse(localStorage.getItem("currUserType"));
    const { fetchingOfficeEmployeeTableData, officeEmployeeTableFetchError } =
      this.state;
    const isEmptyData = this.state.officeEmployeeTableData.length === 0;
    return (
      <div className="fse-table-container">
        <div className="button-filter-search">
          {userType !== "agency_user" && (
            <Button
              node="button"
              style={{
                marginRight: "20px",
                backgroundColor: "white",
                borderRadius: "4px",
                color: "#434364",
                boxShadow: "none",
                border: "1px solid #EAEAEA",
                height: "40px",
                textTransform: "none",
              }}
              waves="light"
              onClick={() => {
                this.showCreateModal();
                this.reset_toggle();
              }}
            >
              <Icon left>add</Icon>
              Create Back-office employee
            </Button>
          )}
          <CreateModal
            handleHide={this.hideCreateModal}
            show={this.state.showCreateModal}
            id={this.state.id}
            name={this.state.name}
            phone={this.state.phone}
            agency={this.state.agency}
            handleSubmit={this.handleSubmit}
            reset={this.state.reset}
            reset_toggle={this.reset_toggle}
          />
          <div className="grouped-filter-search">
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By Distributor"
                items={this.state.agencies}
                multiselect
                onChange={this.handleOptionChange}
              />
            </div>

            <div className="filter-by-agency">
              <Dropdown
                title="Filter By type"
                items={empolyee_types}
                multiselect
                onChange={this.handleTypeChange}
              />
            </div>
            <div className="searchbox">
              <TextInput
                id="TextInput-4"
                placeholder="Employee name/number"
                icon="search"
                onChange={this.handleSearch}
              />
            </div>
          </div>
        </div>

        <Pagination
          page={"fsetable"}
          currentPage={this.props.currentPage}
          total={this.state.total}
          limit={this.props.currentLimit}
        />

        {show_checkBoxes.map((i) => (
          <FormControlLabel
            key={i.value}
            style={{ marginLeft: 5 }}
            control={
              <Checkbox
                checked={this.state.showOfficeEmployeeByActivation === i.value}
                onChange={() =>
                  this.toggleShowOfficeEmployeeByActivation(i.value)
                }
                name={i.label}
              />
            }
            label={i.label}
          />
        ))}

        <div className="worker-table">
          <table>
            {!(this.state.officeEmployeeFetchError || isEmptyData) && (
              <thead>
                <tr>
                  <th className="name">Employee name</th>
                  <th className="fse-id">ID Number</th>
                  <th className="phone">Phone Number</th>
                  <th className="agency">Agency</th>
                  <th className="leave">Leave Day</th>
                  <th className="manage-button">Manage</th>
                </tr>
              </thead>
            )}

            <tbody>
              {fetchingOfficeEmployeeTableData ? (
                Array.from({
                  length: parseInt(this.props.currentLimit),
                }).map((_, index) => (
                  <SkeletonRow key={index} columnCount={6} index={index} />
                ))
              ) : officeEmployeeTableFetchError ? (
                <tr>
                  <td colSpan={6}>
                    <ErrorCard
                      title="Error loading data"
                      message="Failed to load data. Please try again."
                      onRetryClick={this.getData}
                    />
                  </td>
                </tr>
              ) : isEmptyData ? (
                <tr>
                  <td colSpan={6}>
                    <EmptyCard
                      title="No data available"
                      message="No employees found. Please adjust your filters or search."
                    />
                  </td>
                </tr>
              ) : (
                this.state.officeEmployeeTableData.map((worker) => (
                  <TableWorker key={worker.id} data={worker} />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  let currentLimit = state.paginationLimit.fsetable
    ? state.paginationLimit.fsetable.currentLimit
    : state.paginationLimit.default.currentLimit;

  let currentPage = state.page.fsetable
    ? state.page.fsetable.currentPage
    : state.page.default.currentPage;

  return { currentLimit, currentPage };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page, currentPage) => dispatch(setPage(page, currentPage)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BackOfficeEmployeeTable);
